import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import { faAngleRight, faAngleLeft, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faGlobe, faCheck, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { faFacebook, faInstagram, } from '@fortawesome/free-brands-svg-icons';
// Build icon library
library.add(faAngleRight, faAngleLeft, faAngleDown, faAngleUp, faPhoneAlt, faEnvelope, faMapMarkerAlt, faTimes, faGlobe, faCheck, faFacebook, faInstagram, faChevronRight);
// Register fa-icon component globally
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);
export default library;
